import { useMutation } from "@apollo/client";
import { graphql } from "gql/apollo";
import { useCallback } from "react";
import { ListContactGroups } from "../queries/useListContactGroups";
import { ListContacts } from "../queries/useListContacts";

export const DeleteContact = graphql(/* GraphQL */ `
	mutation DeleteContact($params: DeleteContactParams!) {
		deleteContact(params: $params) {
			error {
				code
				message
			}
			success
		}
	}
`);

export function useDeleteContact() {
	const [deleteContact] = useMutation(DeleteContact, {
		refetchQueries: [ListContacts, ListContactGroups],
	});

	const handleDeleteContact = useCallback(
		async (gid: GID) => {
			const result = await deleteContact({
				variables: {
					params: {
						gid,
					},
				},
			});

			return {
				success: result.data?.deleteContact.success,
				error: result.data?.deleteContact.error,
			};
		},
		[deleteContact]
	);

	return { handleDeleteContact };
}
